import * as analysis from '../services/analysis';

export default {
  namespace: 'analysis',

  state: {
    memberCount: null,
    orderAmountNum: null,
    orderCount: null,
    orderPair: null,
    newMemberOrderCount: null,
    newMemberPercent: null,
    noMemberOrderCount: null,
    noMemberPercent: null,
    oldMemberOrderCount: null,
    oldMemberPercent: null,
    firstPurchaseMember: null,
  },

  effects: {
    *getMemberAnalysis({ payload: { values } }, { all, call, put }) {
      const [memberCount, orderAmount] = yield all([
        call(analysis.getMemberCount, values),
        call(analysis.getOrderAmount, values),
      ]);
      yield put({
        type: 'save',
        payload: {
          memberCount: memberCount.data,
          orderAmountNum: orderAmount.data?.salesPaid,
          orderCount: orderAmount.data?.orderCount,
          orderPair: orderAmount.data?.salesQuantity,
          // 新会员订单笔数
          newMemberOrderCount: orderAmount.data?.newMemberOrderCount,
          // 新会员销售占比
          newMemberPercent: orderAmount.data?.newMemberPercent,
          // 非会员订单笔数
          noMemberOrderCount: orderAmount.data?.noMemberOrderCount,
          // 非会员销售占比
          noMemberPercent: orderAmount.data?.noMemberPercent,
          // 老会员订单笔数
          oldMemberOrderCount: orderAmount.data?.oldMemberOrderCount,
          // 老会员销售占比
          oldMemberPercent: orderAmount.data?.oldMemberPercent,
          firstPurchaseMember: orderAmount.data?.firstPurchaseMember,
        },
      });
    },
    *getOrderSalesList({ payload: { values } }, { call, put }) {
      const response = yield call(analysis.getOrderSalesList, values);
      yield put({
        type: 'save',
        payload: {
          orderSalesList: response?.data?.pageResponse,
          oldMemberOrderCount:
            response?.data?.amountResponse?.oldMemberOrderCount,
          oldMemberPercent: response?.data?.amountResponse?.oldMemberPercent,
          firstPurchaseMember:
            response?.data?.amountResponse?.firstPurchaseMember,
          noMemberPercent: response?.data?.amountResponse?.noMemberPercent,
          noMemberOrderCount:
            response?.data?.amountResponse?.noMemberOrderCount,
          newMemberPercent: response?.data?.amountResponse?.newMemberPercent,
          newMemberOrderCount:
            response?.data?.amountResponse?.newMemberOrderCount,
          orderPair: response?.data?.amountResponse?.salesQuantity,
          orderCount: response?.data?.amountResponse?.orderCount,
          orderAmountNum: response?.data?.amountResponse?.salesPaid,
          memberCount: response?.data?.amountResponse?.registerCount,
          totalPurchaseMember:
            response?.data?.amountResponse?.totalPurchaseMember,
          vipOrderCount: response?.data?.amountResponse?.vipOrderCount,
          vipSeatCount: response?.data?.amountResponse?.vipSeatCount,
          vipSalesPaid: response?.data?.amountResponse?.vipSalesPaid,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {},
};
